import React from 'react';
import { FieldProps, Team } from '../../types';

export const TeamTitle: React.FC<FieldProps<Team>> = ({ record }) => (
    <span>{record!.name ? `${record!.name}` : `Team #${record!.id}`}</span>
);
